import React from "react"
import "./skills.css"
import SkillCard from "./SkillCard"

const languageSkills = [
  { name: "PHP", level: "Advanced" },
  { name: "JavaScript", level: "Advanced" },
  { name: "Node.js", level: "Intermediate" },
  { name: "Laravel", level: "Advanced" },
  { name: "React", level: "Intermediate" },
  { name: "Tailwind CSS", level: "Intermediate" },
]

const devToolSkills = [
  { name: "MySQL / SQL", level: "Advanced" },
  { name: "GraphQL", level: "Intermediate" },
  { name: "REST API", level: "Advanced" },
  { name: "GitHub", level: "Advanced" },
  { name: "Agile / SCRUM", level: "Advanced" },
  { name: "Figma", level: "Intermediate" },
]

const Skills = () => {
  return (
    <div className="skills section" id="skills">
      <h2 className="section__title">Skills</h2>
      <span className="section__subtitle">My Technical Skills</span>

      <div className="skills__container container grid">
        <SkillCard title="Language & Frameworks" skills={languageSkills} />
        <SkillCard title="Databases & Dev Tools" skills={devToolSkills} />
      </div>
    </div>
  )
}

export default Skills
